import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        list_players: {
          header: 'PLAYER_LIST_HEADER',
          download_report: 'DOWNLOAD_REPORT',
        },
      },
    },
  }));
}
